import type {DomainsBaseStyles} from '../../types'
import {defaultStyles} from '../default-styles'

export const bestCarGearPicksStylesUS: DomainsBaseStyles = {
  ...defaultStyles,
  COMMONS_APPBAR_BG: 'bg-[#000000]',
  COMMONS_FOOTER_BG: 'bg-[#000000]',

  HOMEPAGE_RANK_BANNER_BG: 'bg-[#000000]',
  HOMEPAGE_HEADER_TITLE_STAR: 'before:text-[#00b20a]',

  HOMEPAGE_RANK_BANNER_TEXT: 'text-white',
  HOMEPAGE_CATEGORIES_CARD_BORDER: 'border-[#000000]',
  HOMEPAGE_TOP_DISCOUNTED_BG: 'bg-[#00b20a]',
  HOMEPAGE_BUTTON_PRIMARY:
    'bg-[#ff8038] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_SECONDARY:
    'border-[#ff8038] text-[#ff8038] [&>svg>path]:stroke-[#ff8038] [&>svg>g>path]:stroke-[#ff8038] [&>svg>path]:fill-[#ff8038] [&>svg>g>path]:fill-[#ff8038]',
  HOMEPAGE_BUTTON_ARROW_BG: 'bg-[#ff8038]',
  HOMEPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  HOMEPAGE_DID_YOU_KNOW_CTA: 'bg-[#000000]',
  HOMEPAGE_DID_YOU_KNOW_BG: 'bg-white',
  HOMEPAGE_DID_YOU_KNOW_TEXT: 'text-black',
  HOMEPAGE_ON_SALE_CTA: 'bg-[#00b20a]',
  HOMEPAGE_EXPLORE_BANNER_BG: 'bg-white',
  HOMEPAGE_EXPLORE_BANNER_TEXT: 'text-black',
  HOMEPAGE_EXPLORE_BANNER_TEXT_STAR: 'before:text-black',
  HOMEPAGE_EXPLORE_BANNER_ICONS:
    '[&>.explore-icon-bg]:!fill-[#000000] [&>.explore-icon-fill]:!fill-white [&>g>.explore-icon-fill]:!fill-white',
  HOMEPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-white [&>.vector-top>path]:fill-[#000000] [&>.vector-bottom>path]:fill-[#000000]',

  HOMEPAGE_CONTENT_DIVIDER: 'bg-[#000000]',
  LISTPAGE_BADGE_WINNER_DIVIDER: '!divide-[#000000]',
  LISTPAGE_BADGE_BEST_VALUE_DIVIDER: '!divide-[#000000]',
  LISTPAGE_BUTTON_NEW_LAYOUT_SECONDARY:
    'border-[#000000] text-[#000000] [&>svg>path]:stroke-[#000000] [&>svg>g>path]:stroke-[#000000] [&>svg>path]:fill-[#000000] [&>svg>g>path]:fill-[#000000]',
  LISTPAGE_BUTTON_SECONDARY:
    'border-[#000000] text-[#000000] [&>svg>path]:stroke-[#ff8038] [&>svg>g>path]:stroke-[#ff8038] [&>svg>path]:fill-[#ff8038] [&>svg>g>path]:fill-[#ff8038]',
  LISTPAGE_BADGE_PLACEMENT_TEXT: 'text-[#000000]',
  LISTPAGE_BADGE_WINNER_TEXT: 'text-[#000000]',

  LISTPAGE_BADGE_SCORE_TEXT: 'text-[#000000]',
  LISTPAGE_BADGE_EDITORS_CHOICE_TEXT: 'text-[#000000]',
  LISTPAGE_BADGE_EDITORS_CHOICE_ICON_STROKE: 'stroke-[#000000]',
  LISTPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#ffee00] [&>.vector-top>path]:fill-[#000000] [&>.vector-bottom>path]:fill-[#000000]',
  LISTPAGE_WIDGETS_SPECS_CHECKED_ICON: '[&>circle]:fill-[#ffee00] [&>circle]:stroke-[#ffee00] [&>path]:fill-[#000000]',
  LISTPAGE_BUTTON_PRIMARY:
    'bg-[#ff8038] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_PRIMARY:
    'bg-[#ff8038] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_LINK: 'text-[#ff8038]',
  LISTPAGE_ANCHOR_LINK: 'text-[#ff8038]',
  LISTPAGE_BUTTON_NEW_LAYOUT_LINK: 'text-[#ff8038] [&_path]:fill-[#ff8038] [&_path]:stroke-[#ff8038]',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_BG: 'bg-[#ff8038]',
  LISTPAGE_BUTTON_ICON_FILL: 'fill-[#ff8038]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_FILL: 'fill-[#ff8038]',
  LISTPAGE_BUTTON_ICON_STROKE: 'stroke-[#ff8038]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_STROKE: 'stroke-[#ff8038]',
  LISTPAGE_USER_VALUE_BADGE: 'text-gray-900 [&>div>svg>path]:fill-[#030303] bg-[#ffee00]',
  LISTPAGE_BADGE_PLACEMENT_BG: 'bg-[#ffee00]',
  LISTPAGE_BADGE_BEST_VALUE_BG: 'bg-[#ffee00]',
  LISTPAGE_BADGE_WINNER_BG: 'bg-[#ffee00]',
  LISTPAGE_BADGE_CTA_DISCOUNT_BG: 'bg-[#ffee00]',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_BG: 'bg-[#ffee00]',
  LISTPAGE_BADGE_SPONSORED_BG: 'bg-[#00b20a]',
  LISTPAGE_BADGE_CARD_DISCOUNT_BG: 'bg-[#00b20a] text-white',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_BG: 'bg-[#00b20a]',
  LISTPAGE_BUTTON_ARROW_BG: 'bg-[#00b20a]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_BG: 'bg-[#00b20a]',

  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_TEXT: 'text-white',
}
